import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '../../../components/dialog/Dialog';
import EyeIcon from '../../../components/icon/EyeIcon';
import { useParams } from 'react-router';
export interface LoginDialogProps extends DialogProps {
    onClickPreview: () => void;
    title?: string;
    claimToken: string;
}
const LoginDialog: FC<LoginDialogProps> = ({
    open,
    onClickPreview,
    title = 'Create a free Menuzen account to publish.',
    claimToken,
    ...props
}) => {
    const { accountId } = useParams<{ accountId: string }>();

    const redirectUrl = process.env.REACT_APP_ENDPOINT + '/claim/' + accountId + '?token=' + claimToken;
    const signUpUrl = process.env.REACT_APP_AUTH_ENDPOINT + '/signup?redirect_uri=' + encodeURIComponent(redirectUrl);
    const loginUrl = process.env.REACT_APP_AUTH_ENDPOINT + '/login?redirect_uri=' + encodeURIComponent(redirectUrl);

    return (
        <Dialog open={open} {...props} anchor="bottom">
            <div className={`px-28 pt-15 pb-43`}>
                <p className="text-25 font-bold mb-16 leading-26 text-center">{title}</p>
                <div className="flex flex-col gap-10">
                    <Button onClick={onClickPreview} variant={`outlined`} fullWidth>
                        <EyeIcon /> <span className={'ml-10'}>Preview</span>
                    </Button>
                    <Button href={signUpUrl} color={`primary`} variant={`contained`} fullWidth>
                        Sign Up
                    </Button>
                </div>
                <div className="mt-15 text-center gap-16 flex flex-col">
                    <div className="text-primary-80 text-center">
                        Already have an account?{' '}
                        <a className="font-bold underline" href={loginUrl}>
                            Log In
                        </a>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default LoginDialog;
